export const START_CHECK_DEVICE_SESSION_TRANSPORT = 'user/START_CHECK_DEVICE_SESSION_TRANSPORT'
export const SAVE_CHECK_DEVICE_SESSION_TRANSPORT = 'user/SAVE_CHECK_DEVICE_SESSION_TRANSPORT'
export const ERROR_CHECK_DEVICE_SESSION_TRANSPORT = 'user/ERROR_CHECK_DEVICE_SESSION_TRANSPORT'
